// 出厂默认值检测：默认机名 / 默认管理密码 —— 命中即提示用户尽快修改
const DEFAULT_NAMES = ["slim wall", "mini wall", "slim tower 2.0", "mega wall 2.0"];

export const isDefaultMachineName = name => DEFAULT_NAMES.indexOf(String(name || "").trim().toLowerCase()) !== -1;

// 默认管理密码 "VapeTM"（比较时忽略大小写与空格，"Vape TM" 亦命中）
export const isDefaultAdminPassword = pwd => String(pwd || "").replace(/\s+/g, "").toLowerCase() === "vapetm";

export default { isDefaultMachineName, isDefaultAdminPassword };
